// src/components/events/EventRouter.jsx
import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { fetchOrganizerSettings, clearOrganizerSettings } from "../../src/app/features/organizer/organizerSettingsSlice";
import EventNavbar from "../components/template/EventNavbar";
import OrganizerPage from "../components/organizer/OrganizerPage";
import EventFooter from "../components/template/EventFooter";
import Navbar from "../components/template/Navbar";
import Footer from "../components/template/Footer";
import EventDetailPage from "../components/events/EventDetailPage";
import { BeatLoader } from "react-spinners";

const EventRouter = () => {
  const { slug } = useParams();
  const dispatch = useDispatch();
  const { data: settings, loading, error } = useSelector(
    (state) => state.organizerSettings
  );

  useEffect(() => {
    if (!slug) return;
    // Clear old data when slug changes
    dispatch(clearOrganizerSettings());
    // Fetch new organizer settings
    dispatch(fetchOrganizerSettings(slug));
  }, [dispatch, slug]);

  const companyName = settings && settings.company_name ? settings.company_name : null;


  if (loading && !settings) {
    return (
      <div className="loader-in-component-body">
        <BeatLoader color="#C6153B" />
      </div>
    );
  }

  if (error) {
    return (
       <>
      <Navbar />
       <div className="App min-vh-100">
      <EventDetailPage pageTitle="Event Detail" />
      </div>
      <Footer />
    </>
    );
  }

  if (companyName) {
    return (
      <>
        <EventNavbar />
      <div className="App min-vh-100">
        <OrganizerPage pageTitle="Organizer Detail" />
      </div>
        <EventFooter />
      </>
    );
  }

  return (
    <>
      <Navbar />
      <EventDetailPage pageTitle="Event Detail" />
      <Footer />
    </>
  );
};

export default EventRouter;
